import { useState } from "react";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import LoadingButton from "@mui/lab/LoadingButton";
import DownloadIcon from "@mui/icons-material/Download";
import AppDialog from "~/shared/ui/AppDialog";
import { useNotify } from "~/shared/ui/feedback/SnackbarProvider";
import { downloadContract } from "~/services/antecipebackoffice/advanceRequest";

const OPTIONS = [
  { value: "PF", label: "Pessoa Física" },
  { value: "PJ", label: "Pessoa Jurídica" },
];

const GenerateContractModal = ({ open, setOpen, handleClose, advancePaymentSelected }) => {
  const notify = useNotify();
  const [contractType, setContractType] = useState("PF");
  const [loading, setLoading] = useState(false);
  const [problem, setProblem] = useState(null); // { severity, message }

  const close = (e) => {
    if (loading) return;
    if (typeof handleClose === "function") handleClose(e);
    setOpen(false);
  };

  const generate = async () => {
    setLoading(true);
    setProblem(null);
    try {
      await downloadContract(advancePaymentSelected.id, contractType);
      setLoading(false);
      setOpen(false);
      notify({ severity: "success", message: "Contrato gerado com sucesso!" });
    } catch (e) {
      setLoading(false);
      setProblem({ severity: e.name === "without-data" ? "warning" : "error", message: e.message });
    }
  };

  return (
    <AppDialog
      open={open}
      onClose={close}
      size="sm"
      busy={loading}
      title="Gerar contrato"
      context={`Médico: ${advancePaymentSelected.doctor_name} · Pacote #${advancePaymentSelected.id}`}
      footerLeft={loading ? <Typography variant="caption" color="text.secondary">*Isso pode levar alguns segundos por favor aguarde...</Typography> : null}
      actions={
        <>
          <Button onClick={close} disabled={loading} sx={{ color: "text.primary" }}>Cancelar</Button>
          <LoadingButton variant="contained" loading={loading} startIcon={<DownloadIcon />} onClick={generate}>Gerar Contrato</LoadingButton>
        </>
      }
    >
      <Stack spacing={1.5}>
        <Typography variant="caption" color="text.secondary">Tipo de contrato</Typography>
        <RadioGroup value={contractType} onChange={(e) => setContractType(e.target.value)} sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: 1 }}>
          {OPTIONS.map((o) => (
            <FormControlLabel key={o.value} value={o.value} control={<Radio />} label={o.label} sx={{ m: 0, border: "1px solid", borderColor: contractType === o.value ? "primary.main" : "divider", borderRadius: 2, pr: 1 }} />
          ))}
        </RadioGroup>
        {problem && <Alert severity={problem.severity}>{problem.message}</Alert>}
      </Stack>
    </AppDialog>
  );
};

export default GenerateContractModal;
